import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22typography.ts%22,%22import%22:%22Sofia_Sans%22,%22arguments%22:[{%22weight%22:[%22400%22,%22800%22],%22style%22:[%22normal%22,%22italic%22],%22subsets%22:[%22latin%22],%22display%22:%22swap%22}],%22variableName%22:%22bodyFont%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Sofia Sans', 'Sofia Sans Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
